import exp from './exception'
import workspace from './workspace'
import login from './auth'
import { RouteRecordRaw } from 'vue-router'

export default <Array<RouteRecordRaw>>[...login, ...workspace, ...exp]
